"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrevPeriod = (currentPeriod, periods) => {
    const index = periods.findIndex(({ code }) => currentPeriod === code);
    return index < 1 ? undefined : periods[index - 1];
};
//# sourceMappingURL=getPrevPeriod.js.map